import { ModelConfigParams, genericApplicationChecklistMFG, genericApplicationChecklistQC } from "./model-config-params";

export const neurofibroma: ModelConfigParams = {
  bodyParts: [
    'kidney',
    'artery',
    'vein',
    'spleen',
    'bone',
    'liver',
    'stomach',
    'bladder',
    'portalVein',
    'gallBladder',
    'lung',
    'airway',
    'skin',
    'bodyFat',
    'colon',
    'bowel',
    'nerve',
    'prostate',
    'pancreas',
    'rightPelvis',
    'muscleLeftRight',
    'tumour',
    'cyst',
    'thyroid',
  ],
  checklist: genericApplicationChecklistMFG,
  checklistQC: genericApplicationChecklistQC,
  defaultIntensityRange: [0, 2000],
  internal: true,
}
